export default __webpack_public_path__ + "static/media/greenline-logo.13239b6a.svg";